"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CVCField = exports.ExpirationDateField = exports.CardNumberField = void 0;
const react_1 = __importStar(require("react"));
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const index_1 = require("../index");
// @ts-ignore
const StripeInput = ({ component: Component, inputRef, ...props }) => {
    const elementRef = (0, react_1.useRef)();
    (0, react_1.useImperativeHandle)(inputRef, () => ({
        // @ts-ignore
        focus: () => elementRef.current.focus,
    }));
    // @ts-ignore
    return react_1.default.createElement(Component, { onReady: (element) => (elementRef.current = element), ...props });
};
const CardNumberField = ({ label = 'Debit Card Number', ...rest }) => (react_1.default.createElement(index_1.TextField, { ...rest, label: label, InputLabelProps: { shrink: true }, InputProps: {
        inputComponent: StripeInput,
        inputProps: {
            component: react_stripe_js_1.CardNumberElement,
            options: {
                showIcon: true,
            },
        },
    } }));
exports.CardNumberField = CardNumberField;
const ExpirationDateField = ({ label = 'Expiration Date', ...rest }) => (react_1.default.createElement(index_1.TextField, { ...rest, label: label, InputLabelProps: { shrink: true }, InputProps: {
        inputComponent: StripeInput,
        inputProps: {
            component: react_stripe_js_1.CardExpiryElement,
        },
    } }));
exports.ExpirationDateField = ExpirationDateField;
const CVCField = ({ label = 'CVC', ...rest }) => (react_1.default.createElement(index_1.TextField, { ...rest, label: label, InputLabelProps: { shrink: true }, InputProps: {
        inputComponent: StripeInput,
        inputProps: {
            component: react_stripe_js_1.CardCvcElement,
        },
    } }));
exports.CVCField = CVCField;
